import * as Yup from "yup";
import { lang } from "../Utils/lang";
import { passwordModel } from "./RegisterModel";

export const UserModel = Yup.object().shape({
  username: Yup.string().required(lang.required),
  email: Yup.string()
    .required(lang.required)
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      lang.invalidEmail
    ),
  password: passwordModel,
  rolesArray: Yup.array().required(lang.required).default(["ROLE_USER"]),
});
